export const PHONE = "+918447496808";
export const PHONE_DISPLAY = "+91 84474 96808";
export const SECONDARY_PHONE_DISPLAY = "+91 95607 26989";
export const EMAIL = "justudylibrary@gmail.com";

// Brand assets
export const LOGO =
  "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/peeezf8j_WhatsApp%20Image%202026-06-11%20at%2013.15.27%20%281%29.jpeg";
export const BRAND_BANNER =
  "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/st5kqxan_WhatsApp%20Image%202026-06-11%20at%2013.15.26.jpeg";

export const waLink = (text = "Hello Justudy Library, I'd like to know more about seat availability and fees.") =>
  `https://wa.me/918447496808?text=${encodeURIComponent(text)}`;

export const telLink = `tel:+918447496808`;

export const BRANCHES = {
  s22: {
    id: "s22",
    name: "Sector 22 Noida",
    title: "Justudy Library – Sector 22 Noida",
    address:
      "2nd Floor, Moolchand Tower, Above Bank of India, Block I, Sector 22, Noida, Uttar Pradesh 201301",
    timing: "Open 24/7",
    timingShort: "24/7",
    mapsEmbed:
      "https://www.google.com/maps?q=Justudy+Library+%26+co-working+space+Moolchand+Tower+Sector+22+Noida&output=embed",
    mapsLink:
      "https://www.google.com/maps/dir/?api=1&destination=Justudy+Library+%26+co-working+space%2C+Moolchand+Tower%2C+Sector+22%2C+Noida",
    reviewLink:
      "https://search.google.com/local/writereview?placeid=&q=Justudy+Library+Sector+22+Noida",
    features: [
      "Silent study environment",
      "AC rooms",
      "High-speed Wi-Fi",
      "CCTV security",
      "Power backup",
      "Lockers",
      "Parking space",
      "Hot & cold water",
      "LED lights",
      "Charging points",
      "Pinboards on every desk",
      "Kitchen available",
      "Students can order food",
    ],
  },
  s26: {
    id: "s26",
    name: "Sector 26 Noida",
    title: "Justudy Library – Sector 26 Noida",
    address: "B-8, Sector 26, Noida, Uttar Pradesh 201301",
    timing: "8:00 AM to 10:00 PM",
    timingShort: "8 AM – 10 PM",
    mapsEmbed:
      "https://www.google.com/maps?q=Justudy+Library+study+and+co-working+space+B-8+Sector+26+Noida&output=embed",
    mapsLink:
      "https://www.google.com/maps/dir/?api=1&destination=Justudy+Library+study+and+co-working+space%2C+B-8%2C+Sector+26%2C+Noida",
    reviewLink:
      "https://search.google.com/local/writereview?placeid=&q=Justudy+Library+Sector+26+Noida",
    features: [
      "Silent study environment",
      "AC rooms",
      "High-speed Wi-Fi",
      "CCTV security",
      "Newspaper",
      "Network booster",
      "Power backup",
      "Lockers",
      "Parking space",
      "Hot & cold water",
      "LED lights",
      "Charging points",
      "Pinboards on every desk",
    ],
  },
};

export const FACILITIES = [
  { label: "High-Speed Wi-Fi", icon: "Wifi" },
  { label: "CCTV Security", icon: "Video" },
  { label: "Newspaper", icon: "Newspaper" },
  { label: "AC Rooms", icon: "AirVent" },
  { label: "Network Booster", icon: "SignalHigh" },
  { label: "Lockers", icon: "Lock" },
  { label: "Power Backup", icon: "Zap" },
  { label: "Parking Space", icon: "ParkingSquare" },
  { label: "Hot & Cold Water", icon: "GlassWater" },
  { label: "LED Lights", icon: "Lightbulb" },
  { label: "Charging Points", icon: "Plug" },
  { label: "Pinboards on Every Desk", icon: "Clipboard" },
  { label: "Kitchen Facility (Sec 22)", icon: "ChefHat" },
  { label: "Food Ordering (Sec 22)", icon: "Utensils" },
];

export const FEES = {
  s22: {
    branch: "Sector 22 Noida",
    timing: "Open 24/7",
    categories: [
      {
        title: "Hall Membership Plans",
        timing: "7 AM – 10 PM",
        plans: [
          { name: "Monthly Plan", price: "₹1,250", remark: "Unreserved Seat" },
          { name: "Monthly Plan", price: "₹1,500", remark: "Reserved Seat" },
          { name: "3 Months Plan", price: "₹3,900", remark: "Reserved Seat" },
          { name: "6 Months Plan", price: "₹7,200", remark: "Reserved Seat" },
          { name: "Locker Charges", price: "₹150", remark: "Per Month" },
        ],
      },
      {
        title: "Deluxe Room Membership",
        timing: "7 AM – 10 PM",
        highlight: true,
        plans: [
          { name: "Monthly Plan", price: "₹1,800", remark: "Reserved Seat" },
        ],
      },
      {
        title: "Night Shift",
        timing: "9 PM – 7 AM",
        plans: [
          { name: "Monthly Plan", price: "₹1,000", remark: "Unreserved Seat" },
        ],
      },
      {
        title: "Weekend Plan (Sat + Sun)",
        timing: "7 AM – 10 PM",
        plans: [
          { name: "Weekend Monthly", price: "₹500", remark: "Unreserved Seat" },
        ],
      },
      {
        title: "Evening Shift After 4 PM",
        timing: "4 PM – 10 AM",
        plans: [
          { name: "3 Hours", price: "₹500", remark: "Unreserved Seat" },
          { name: "4 Hours", price: "₹600", remark: "Unreserved Seat" },
          { name: "5 Hours", price: "₹700", remark: "Unreserved Seat" },
          { name: "6 Hours", price: "₹800", remark: "Unreserved Seat" },
          { name: "8 Hours", price: "₹1,000", remark: "Unreserved Seat" },
        ],
      },
    ],
    addon: "Add-on Weekend Plan: ₹299 monthly extra",
  },
  s26: {
    branch: "Sector 26 Noida",
    timing: "8 AM – 10 PM",
    categories: [
      {
        title: "Hall Membership Plans",
        timing: "8 AM – 10 PM",
        plans: [
          { name: "Monthly Plan", price: "₹1,250", remark: "Unreserved Seat" },
          { name: "Monthly Plan", price: "₹1,500", remark: "Reserved Seat" },
          { name: "3 Months Plan", price: "₹3,900", remark: "Reserved Seat" },
          { name: "6 Months Plan", price: "₹7,200", remark: "Reserved Seat" },
          { name: "Locker Charges", price: "₹150", remark: "Per Month" },
        ],
      },
      {
        title: "Weekend Plan (Sat + Sun)",
        timing: "8 AM – 10 PM",
        plans: [
          { name: "Weekend Monthly", price: "₹500", remark: "Unreserved Seat" },
        ],
      },
      {
        title: "Evening Shift After 4 PM",
        timing: "4 PM – 10 AM",
        plans: [
          { name: "3 Hours", price: "₹500", remark: "Unreserved Seat" },
          { name: "4 Hours", price: "₹600", remark: "Unreserved Seat" },
          { name: "5 Hours", price: "₹700", remark: "Unreserved Seat" },
          { name: "6 Hours", price: "₹800", remark: "Unreserved Seat" },
          { name: "8 Hours", price: "₹1,000", remark: "Unreserved Seat" },
        ],
      },
    ],
    addon: "Add-on Weekend Plan: ₹299 monthly extra",
  },
};

export const GALLERY = [
  { type: "video", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/br4mwv2a_WhatsApp%20Video%202026-06-11%20at%2013.57.43%20%281%29.mp4" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/0ktwjciz_WhatsApp%20Image%202026-06-11%20at%2013.57.43.jpeg" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/eowbaxqp_WhatsApp%20Image%202026-06-11%20at%2013.57.44.jpeg" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/pgv2j0vm_WhatsApp%20Image%202026-06-11%20at%2013.57.41.jpeg" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/xm1adlbp_WhatsApp%20Image%202026-06-11%20at%2013.57.41%20%281%29.jpeg" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/pg91piza_WhatsApp%20Image%202026-06-11%20at%2013.57.34.jpeg" },
  { type: "video", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/eh0msw11_WhatsApp%20Video%202026-06-11%20at%2013.57.44.mp4" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/emy0eyfq_WhatsApp%20Image%202026-06-11%20at%2013.57.36.jpeg" },
  { type: "image", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/vhw3penw_WhatsApp%20Image%202026-06-11%20at%2013.57.40.jpeg" },
  { type: "video", src: "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/8gbcoo3n_WhatsApp%20Video%202026-06-11%20at%2013.57.43.mp4" },
];

export const HERO_BG =
  "https://customer-assets.emergentagent.com/job_library-cowork-hub/artifacts/xm1adlbp_WhatsApp%20Image%202026-06-11%20at%2013.57.41%20%281%29.jpeg";
